export const npcs = {
    "克鲁格": {
        "克鲁格": "NPC-Kyruger.png"
    },
    "赫丽安": {
        "赫丽安": "NPC-Helian.png"
    },
    "格琳": {
        "格琳": "NPC_Kalina.png",
        "自由街头": "NPC_Kalina_202.png",
        "青春弧光": "NPC_Kalina_201.png",
        "摇滚乐手": "NPC_Kalina_203.png",
        "格里芬制服": "NPC_Kalina_204.png",
        "钻石与烟花": "NPC_Kalina_205.png",
        "冬慕派对": "pic_NPC_Kalina_206.png",
        "黑猫小姐": "格林娜-黑猫小姐.png",
        "作战装束": "Kalina_军装.png",
        "记者": "NPC-KalinReporter.png",
        "恋人絮语": "pic_NPC_Kalina_208.png"
    },
    "莱柯": {
        "莱柯": "NPC-Lyco.png"
    },
    "德尔": {
        "德尔": "NPC-Deele.png"
    },
    "希尔": {
        "希尔": "NPC-Seele.png"
    },
    "哈维尔": {
        "哈维尔": "NPC-Havel.png"
    },
    "帕斯卡": {
        "帕斯卡": "NPC-Persica_A.png"
    },
    "泽林斯基": {
        "泽林斯基": "NPC-Zielinski.png"
    },
    "安洁莉娅": {
        "安洁莉娅": "NPC-Ange.png",
        "武装": "NPC-Ange_1.png",
        "重伤": "NPC-AngeStreet.png",
        "西装": "pic_NPC-Ange_2.png"
    },
    "卡特": {
        "卡特": "NPC-Carter.png"
    },
    "叶戈尔": {
        "叶戈尔": "NPC-Yegor.png",
        "重伤": "NPC-YegorDamage.png",
        "副官": "NPC-YegorArm3.png",
        "作战服": "NPC-YegorArm4.png"
    },
    "乌尔利赫主席": {
        "乌尔利赫主席": "NPC-Ambassador.png"
    },
    "K": {
        "K": "NPC-Jason.png",
        "武装": "NPC-Jason_1.png",
        "西装": "pic_NPC-Jason_2.png"
    },
    "J": {
        "J": "pic_NPC-Keven_0.png",
        "负伤": "pic_NPC-Keven_1.png"
    },
    "涅托": {
        "涅托": "Nyto.png",
        "白色人偶": "pic_Nyto_white_LL.png",
        "黑色人偶": "pic_Nyto_black_LL.png",
        "尼莫金": "NPC-Nimogen.png",
        "墨丘萝丝": "NPC-Mercurows.png",
        "遗弃异构体": "Abandoned_Isomer.png",
        "失格异构体": "Nyto_Isomer_White.png",
        "丹德莱": "Nyto_Isomer_Shadow.png"
    },
    "幼年涅托": {
        "安娜": "Nytochild01_1.png",
        "02": "Nytochild02_1.png",
        "03": "Nytochild03_1.png",
        "04": "Nytochild04.png"
    },
    "默莉朵": {
        "默莉朵": "pic_NPC-Morridow_0.png",
        "便服": "pic_NPC-Morridow_1.png"
    },
    "霍普斯": {
        "霍普斯": "pic_NPC-Hopps_0.png"
    },
    "雷奥妮": {
        "雷奥妮": "pic_NPC-Leone_0.png"
    },
    "莉莉安&艾尔莎": {
        "莉莉安&艾尔莎": "pic_NPC-Lilyan_0.png"
    },
    "鲍威尔": {
        "鲍威尔": "pic_NPC-Powell.png"
    },
    "忤逆（不莱梅）": {
        "AK12": "pic_AK12_1.png",
        "AK15": "pic_AK15_1.png",
        "AN94": "pic_AN94_1.png",
        "RPK16": "pic_RPK16_1.png"
    },
    "帕萨杜": {
        "帕萨杜": "Passadou(0).png",
        "弗杜托": "Fuduto(0).png"
    },
    "AH400": {
        "AH400": "AH400(0).png",
        "AH400面具": "AH400_mask.png"
    },
    "阿尔拉": {
        "阿尔拉": "NPC-Arla.png"
    },
    "蒂玛": {
        "蒂玛": "NPC-Dima(0).png"
    },
    "格里芬": {
        "格里芬": "NPC-Griffin(0).png"
    },
    "娜希斯": {
        "娜希斯": "pic_Narciss_LL.png"
    },
    "格雷女士": {
        "格雷女士": "NPC-MrsGray(0).png"
    },
    "莱特": {
        "莱特": "NPC-Light(0).png",
        "负伤": "NPC-Light(4).png"
    },
    "夏朵利兹": {
        "夏朵利兹": "NPC-Shadowless(0).png"
    },
    "玛赫莲": {
        "玛赫莲": "NPC-Machlian(0).png",
        "露面": "NPC-Machlian(1).png",
        "无披肩": "NPC-Machlian(5).png"
    },
    "通用人物": {
        "路人女": "NPC-PasserbyF.png",
        "路人男": "NPC-PasserbyM.png",
        "杂工": "pic_NPC-handyman.png",
        "保镖1": "NPC-Bodyguard1.png",
        "保镖2": "NPC-Bodyguard2.png",
        "士兵": "NPC-YegorArm3.png",
        "老人": "pic_NPC-Oldartist.png",
        "难民": "pic_NPC-Refugee_0.png",
        "女仆人形": "NPC-Maid.png",
        "以利亚": "NPC-Elijah(0).png"
    },
    "宝兰斯诺": {
        "宝兰斯诺1": "NPC_baolan_1.png",
        "宝兰斯诺2": "NPC_baolan_2.png",
        "宝兰斯诺3": "NPC_baolan_3.png",
        "宝兰斯诺4": "NPC_baolan_4.png",
        "宝兰斯诺5": "NPC_baolan_5.png"
    }
}